import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Bank } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles } from './index';
import { SubHeading } from '../investors/components';
import { getBankAddress } from '../../utils/utilityFunctions';
import {
  BankAccountTypeForVenture,
  CurrencyMaster,
  YesNoMaster,
  defaultCurrency,
} from '../../utils/constant';
import { CurrencyList } from '../../redux-store/types/mdms';
import { getCurrencyList } from '../../redux-store/actions';
import { useDispatch } from 'react-redux';

export default function BankDetails({ banks = [] }: { banks: Partial<Bank>[] }): JSX.Element {
  const [currencyList, setCurrencyList] = useState<CurrencyList>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getCurrencyList())) as unknown as CurrencyList;
        setCurrencyList(response as CurrencyList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Investor&apos;s Bank Details
            </Typography>
            {banks.length === 0 ? (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                No Bank Details
              </Grid>
            ) : (
              banks.map((bank, index: number) => {
                const title = ['Bank 1 Details', 'Bank 2 Details', 'Bank 3 Details'][index];
                const bankAddress = getBankAddress(bank.address1, bank.address2, bank.address3);
                return (
                  <React.Fragment key={bank.id}>
                    <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>
                      {/* {title} */}
                      Beneficiary Bank Account Details
                    </SubHeading>
                    <Gridstyles>
                      <Grid
                        item
                        container
                        pt={2}
                        pb={5}
                        rowSpacing={6}
                        columnSpacing={13}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start">
                        <KeyValue
                          title={'Account Holder Name'}
                          description={bank.accountHolderName}
                        />
                        <KeyValue
                          title={'Bank Account Number'}
                          description={bank.bankAccountNumber}
                        />
                        {/* <KeyValue
                          title={'Account Type'}
                          description={BankAccountTypeForVenture[bank?.bankAccountType || '']}
                        /> */}
                        <KeyValue title={'Bank Name'} description={bank.bankName} />
                        {/* <KeyValue title={'Bank Branch'} description={bank.bankBranch} /> */}
                        <KeyValue
                          title={`Bank Address`}
                          description={`${bankAddress}`}
                          sx={{
                            textTransform: 'capitalize',
                          }}
                        />
                        <KeyValue title={`Bank Country`} description={bank.bankCountry} />
                        <KeyValue title={'SWIFT Code'} description={bank.swiftCode} />
                        <KeyValue
                          title={'Currency'}
                          description={
                            bank.currency
                              ? currencyList.find((currency) => currency.value === bank.currency)
                                  ?.key
                              : bank.currency
                          }
                        />
                        {/* <KeyValue
                          title={'IBAN (International Bank Account Number)'}
                          description={bank.ibanNumber}
                        />
                        <KeyValue
                          title={'CIF (Customer Information File) if any'}
                          description={bank.cif}
                        /> */}
                        {/* <KeyValue
                          title={`Default Bank Account`}
                          description={bank.defaultBankAccount ? 'Yes' : '-'}
                        /> */}
                      </Grid>
                    </Gridstyles>
                    <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>
                      {/* {title} */}
                      Correspondence Bank Account Details
                    </SubHeading>
                    <Gridstyles>
                      <Grid
                        item
                        container
                        pt={2}
                        pb={5}
                        rowSpacing={6}
                        columnSpacing={13}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start">
                        <KeyValue title={'Bank Name'} description={bank.correspondenceBankName} />
                        <KeyValue
                          title={'Swift Code'}
                          description={bank.correspondenceBankSwiftCode}
                        />
                        <KeyValue title={'Bank ABA'} description={bank.correspondenceBankAba} />
                        <KeyValue
                          title={'Additional Details'}
                          description={bank.additionalDetails}
                        />
                        <KeyValue
                          title={`Is the Wiring Bank located in "FATF Country"?`}
                          description={YesNoMaster[bank?.isLocatedInFatfCountry || '']}
                        />
                      </Grid>
                    </Gridstyles>
                  </React.Fragment>
                );
              })
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
